var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1797 0C15.8024 0.003353 19.9534 3.24346 22.2848 8.66861C22.3765 8.87985 22.3765 9.11903 22.2848 9.33027C19.9545 14.7565 15.8024 17.9966 11.1797 18H11.173C6.55036 17.9966 2.39935 14.7565 0.0678982 9.33027C-0.0226327 9.11903 -0.0226327 8.87985 0.0678982 8.66861C2.39935 3.24346 6.55147 0.003353 11.173 0H11.1797ZM11.1764 1.6765C7.33608 1.67762 3.83331 4.40807 1.75446 8.99944C3.83331 13.5919 7.33496 16.3224 11.1764 16.3235C15.0178 16.3224 18.5194 13.5919 20.5983 8.99944C18.5194 4.40807 15.0178 1.67762 11.1764 1.6765ZM11.176 4.62803C13.5868 4.62803 15.5483 6.58953 15.5483 9.00034C15.5483 11.41 13.5868 13.3704 11.176 13.3704C8.76523 13.3704 6.80485 11.41 6.80485 9.00034C6.80485 6.58953 8.76523 4.62803 11.176 4.62803ZM11.176 6.30453C9.68954 6.30453 8.48135 7.51384 8.48135 9.00034C8.48135 10.4857 9.68954 11.6939 11.176 11.6939C12.6625 11.6939 13.8718 10.4857 13.8718 9.00034C13.8718 7.51384 12.6625 6.30453 11.176 6.30453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeye);
export default __webpack_public_path__ + "static/media/heye.2b8032c30fb90bedf5fdf0dace52ef3e.svg";
export { ForwardRef as ReactComponent };